// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c1b63f42","703":"cea290d2","787":"a65a6974"}[chunkId] + ".chunk.js";
};